export function calculateOriginPayment(originPayment) {
    switch (originPayment) {
        case "PaymentReminder":
            return "Recordatorio fecha cercana"
        case "ExpirationMessage":
            return "Mensaje vencimiento"
        default:
            return "home"
    }
}